import {GetMyCharacterLevel} from '@/graphql/queries/CharacterLevel.graphql'
import {GetparkProgressBar} from '@/graphql/queries/Park.graphql'

export default {
  data(){
    return {
      progressBarParams             : {
        currentValue  : 0,
        maxValue      : 0
      },
      
      characterProgressBarData      : {
        currentValue  : 0,
        maxValue      : 0
      },

      progressBarType               : 'character',

      progressBarParkId             : null,
      
      parkProgressBarData           : {
        currentValue  : 0,
        maxValue      : 0
      },

      progressBarClass              : {
        'pa-reward-progress-park' : false
      }
    };
  },

  apollo : {
    myCharacterLevel : {
      query : GetMyCharacterLevel,
      skip(){
        return !this.couldDataLoad;
      }
    },

    parkProgressBar : {
      query : GetparkProgressBar,

      variables(){
        return {
          park_id  : this.progressBarParkId
        };
      },

      skip(){
        if(!this.couldDataLoad || this.progressBarParkId === null){
          return true;
        }else{
          return false;
        }
      }
    }
  },

  computed : {
    isMountedLoginedViewPage(){
      return this.$store.state.layouts.isMountedLoginedViewPage;
    },

    routingPosition(){
      return this.$store.state.routingPosition;
    },

    routeParms(){
      return this.$route.params;
    }
  },

  watch : {
    myCharacterLevel : {
      handler(data){
        if(typeof data === 'undefined') return;

        this.characterProgressBarData.currentValue = data.zero_current;
        this.characterProgressBarData.maxValue     = data.zero_end;
      },
      immediate:true,
      deep: true
    },

    parkProgressBar : {
      handler(data){
        if(typeof data === 'undefined') return;
        
        this.parkProgressBarData.currentValue = data.min;
        this.parkProgressBarData.maxValue     = data.max;
      },
      immediate:true,
      deep: true
    },

    routingPosition : {
      handler(value){
        if(typeof value === 'undefined') return;

        this.checkInParkPage();
      },
      immediate: true
    },

    routeParms : {
      handler(data){
        if(typeof data === 'undefined') return;

        this.checkInParkPage();
      },
      immediate: true,
      deep: true
    },

    progressBarType : {
      handler(value){
        if(typeof value === 'undefined') return;

        this.setProgressBarData();
      },
      immediate: true,
      deep:true
    },

    characterProgressBarData : {
      handler(data){
        if(typeof data === 'undefined') return;

        this.setProgressBarData();
      },
      immediate: true,
      deep:true
    },

    parkProgressBarData : {
      handler(data){
        if(typeof data === 'undefined') return;

        this.setProgressBarData();
      },
      immediate: true,
      deep:true
    },
  },

  methods : {
    setProgressBarData(){
      if(this.progressBarType === 'character'){
        this.progressBarParams.currentValue = this.characterProgressBarData.currentValue;
        this.progressBarParams.maxValue     = this.characterProgressBarData.maxValue;

        this.progressBarClass['pa-reward-progress-park'] = false;
      }else{
        this.progressBarParams.currentValue = this.parkProgressBarData.currentValue;
        this.progressBarParams.maxValue = this.parkProgressBarData.maxValue;

        this.progressBarClass['pa-reward-progress-park'] = true;
      }
    },

    checkInParkPage(){
      if(this.routingPosition === 'park'){
        if(typeof this.routeParms.parkId !== 'undefined'){
          this.progressBarType = 'park';
          this.progressBarParkId = this.routeParms.parkId;
          return;
        }
      }

      this.progressBarType   = 'character';
      this.progressBarParkId = null;
    }
  }
}